import { render } from "./UserSubscripsData.vue?vue&type=template&id=4af4ce64"
import script from "./UserSubscripsData.vue?vue&type=script&lang=js"
export * from "./UserSubscripsData.vue?vue&type=script&lang=js"

import "@/styles/profile/users/userSubscripsData.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__